<template>
  <div class="head flex-row justify-between">
    <div class="title">
      <img class="logo" src="../assets/images/logo.png" alt="" />
      <h3 class="tit">笑柚后台管理系统</h3>
    </div>
    <div class="flex">
      <div class="userinfo flex">
        <span style="font-size: 0.16rem"
          >欢迎回来，{{ $store.state.userinfo.userName }}</span
        >

        <div class="headimg size0">
          <!-- <img src="../assets/images/headimg.png" alt="" /> -->
        </div>
        <!-- <span class="name">{{$store.state.userinfo.name?$store.state.userinfo.name:$store.state.userinfo.account}}</span> -->
      </div>
      <div class="logout" @click="logout">
        <span>退出</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userinfo: {}
    };
  },
  mounted() {
    // this.$api.post('login',{'admin':1}).then((result) => {
    //     console.log(result)
    // }).catch((err) => {
    //     console.log(err)
    // });
  },
  methods: {
    logout() {
      this.$confirm("确认退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          localStorage.setItem("userinfo", "");
          localStorage.setItem("role", "");
          localStorage.setItem("navIndex", "");
          localStorage.setItem("questionList", "");
          localStorage.setItem("token", "");
          localStorage.setItem("userPermissions", "");
          this.$store.commit("removeInfo", "");
          this.$router.push({ name: "login" });
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
}
.tit {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 24px;
  color: #363636;
  margin-left: 32px;
}
.head {
  padding: 0 40px 0 36px;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  min-width: 1245.6px;
  // width: 86.5vw;
  height: 0.8rem;
  line-height: 0.8rem;
  background-color: #ffffff;
  border-bottom: 1px solid #eaedf0;
  box-sizing: border-box;
  font-size: 0;
  // box-shadow: 0px 0px 0.1rem #554c4b4d;
  position: relative;
  .userinfo {
    margin-right: 0.2rem;
    .name {
      font-size: 0.18rem;
      color: #44566c;
      display: inline-block;
      padding: 0 0.16rm;
    }
  }
  .headimg {
    width: 0.6rem;
    line-height: 0.8rem;
    img {
      width: 100%;
      display: inline-block;
      margin-top: 0.4rem;
      transform: translateY(-50%);
    }
  }
  .flex {
    justify-content: flex-end;
  }
  .logout {
    // margin-right: 0.7rem;
    cursor: pointer;
    span {
      font-size: 0.18rem;
      color: #44566c;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/isheader.vue